import { render, staticRenderFns } from "./modal-combination.vue?vue&type=template&id=1272b790"
import script from "./modal-combination.vue?vue&type=script&lang=js"
export * from "./modal-combination.vue?vue&type=script&lang=js"
import style0 from "./modal-combination.vue?vue&type=style&index=0&id=1272b790&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports